
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-soundcharts-purple text-white hover:bg-soundcharts-deepPurple",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        soundcharts: 
          "border-soundcharts-purple text-soundcharts-purple bg-soundcharts-purple/10 shadow-soundcharts hover:bg-soundcharts-purple/20",
        "soundcharts-filled": 
          "border-0 bg-soundcharts-gradient text-white",
        "soundcharts-light": 
          "border-soundcharts-lightPurple text-soundcharts-deepPurple bg-soundcharts-lightPurple/20",
        neon: 
          "border-neon-blue text-neon-blue bg-black/50 shadow-neon hover:bg-black/70",
        "neon-purple": 
          "border-neon-purple text-neon-purple bg-black/50 shadow-neon-purple hover:bg-black/70",
        "neon-pink": 
          "border-neon-pink text-neon-pink bg-black/50 shadow-neon-pink hover:bg-black/70",
        "neon-green":
          "border-green-400 text-green-400 bg-black/50 shadow-lg hover:bg-black/70",
        cyber: 
          "border-0 bg-gradient-to-r from-neon-blue to-neon-purple text-white",
        glass: 
          "bg-white/10 backdrop-blur-sm border border-white/20 text-white",
        game:
          "border-neon-purple/50 bg-black/60 text-white shadow-neon-purple backdrop-blur-sm",
        arcade:
          "border-0 bg-gradient-to-r from-neon-pink via-neon-purple to-neon-blue text-white shadow-lg animate-pulse",
        achievement:
          "border-yellow-500/50 bg-yellow-500/20 text-yellow-300 shadow-lg",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
